module.exports = __webpack_public_path__ + "static/media/SmartShop_7-950w.59bbb582.jpg";